/** the `source` the auto-applied coupon event carries so the funnel can tell this apply from a tap */
export const HARDWARE_FIRST_IN_APP_PROMO_SOURCE = 'hardware_first_in_app';

export interface HardwareFirstInAppPromoDecision {
  activePromoCode: string | undefined;
  cartItemCount: number;
  cartCouponCode: string | undefined;
  cartReferralCode: string | undefined;
  redeemedGiftCardCode: string | undefined;
  hasCouponCookie: boolean;
  /** a referral link's cookie, which `useAutoApplyReferral` turns into `cartReferralCode` a beat later */
  hasReferralCookie: boolean;
  /** a gift card cookie, which `useApplyGiftCardFromCookie` redeems onto the cart a beat later */
  hasGiftCardCookie: boolean;
  inPartnerContext: boolean;
  alreadyAttempted: boolean;
}

/**
 * Whether the live promotion's code should be applied to an in-app hardware-first cart. The code is
 * applied once per cart contents, only to a cart with no code of any kind on it, and never over a
 * partner offer or a coupon, referral or gift card cookie the shopper brought with them.
 */
export function shouldAutoApplyHardwareFirstInAppPromo(decision: HardwareFirstInAppPromoDecision): boolean {
  return (
    !!decision.activePromoCode &&
    decision.cartItemCount > 0 &&
    !decision.cartCouponCode &&
    !decision.cartReferralCode &&
    !decision.redeemedGiftCardCode &&
    !decision.hasCouponCookie &&
    !decision.hasReferralCookie &&
    !decision.hasGiftCardCookie &&
    !decision.inPartnerContext &&
    !decision.alreadyAttempted
  );
}
